import React, { useState, useEffect } from 'react';
import PartyUI2 from './PartyUI2';
import PartyUI1 from './PartyUI1';
import { calculateLeads } from './Utils';
import Map from './Map';
import BarChart from './BarChart';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const group1Name = 'GROUP - A';
const group2Name = 'GROUP - B';

const Analysis = (props) => {

    const contentWidth = props.width-10;
    const contentHeight = props.height-94;
    const groupsHeight = (contentHeight-20);
    const groupsWidth = (contentWidth-360)/2;
    const stateIndex = props.stateIndex;
    const partyLogos = props.partyLogos;

    const [dragItem, setDragItem] = useState('');
    const [mapChartRadio, setMapChartRadio] = useState(1);
    const [partyLeadsMap, setPartyLeadsMap] = useState([]);
    const [toolTipObj, setToolTipObj] = useState([]);
    const [displayPartyList, setDisplayPartyList] = useState([]);
    const [filterPartyList, setFilterPartyList] = useState([]);
    const [allPartyList, setAllPartyList] = useState([]);
    const [query, setQuery] = useState('');
    const [group1List, setGroup1List] = useState([]);
    const [group2List, setGroup2List] = useState([]);
    const [statesObject, setStatesObject] = useState({});
    const [mpMla1Count, setMpMla1Count] = useState({ mp: 0, mla: 0 });
    const [mpMla2Count, setMpMla2Count] = useState({ mp: 0, mla: 0 });

    let { resultsMap, currentState, leadPartyMap, constiToolTip, stateResults } = props;

    useEffect(() => {
        let storedStates = JSON.parse(localStorage.getItem('storedStates'));
        let latestPartyList = [];
        if(resultsMap&&resultsMap[currentState]) {
            latestPartyList = getLatestPartyList(resultsMap[currentState]);
            setAllPartyList(latestPartyList);
        }
        if(leadPartyMap[currentState]) {
            console.log('leadPartyMap[currentState]=',leadPartyMap[currentState]);
            setPartyLeadsMap(leadPartyMap[currentState]);
        }
        if(constiToolTip&&constiToolTip[currentState]) {
            console.log('constiToolTip[currentState]=',constiToolTip[currentState]);
            setToolTipObj(constiToolTip[currentState]);
        }
        if (storedStates&&storedStates[currentState]) {
            setStoredStatesData(latestPartyList, storedStates, currentState);
        } else {
            setDisplayPartyList(latestPartyList);
            setFilterPartyList(latestPartyList);
            setGroup1List([]);
            setGroup2List([]);
            setDragItem('');
            setMpMla1Count({ mp: 0, mla: 0 });
            setMpMla2Count({ mp: 0, mla: 0 });
        }
    }, [props]);

    const getLatestPartyList = (currentStatesData) => {
        // console.log('currentStatesData=',currentStatesData);
        let mlaRows = currentStatesData.mla.formattedRows;
        let mpRows = currentStatesData.mp.formattedRows;
        let partyTempList = [];
        if(stateIndex==0) {
            for(let i=0;i<mpRows.length;i++) {
                let { Party, Leads } = mpRows[i];
                let item = { partyId: Party, mpLeads: Leads };
                // console.log('lead temp item=',item);
                partyTempList.push(item);
            }
            partyTempList = partyTempList.sort((a,b) => b.mpLeads-a.mpLeads);
        } else {
            if(mlaRows.length>=1&&currentStatesData.isMLA) {
                for(let i=0;i<mlaRows.length;i++) {
                    let { Party, Leads } = mlaRows[i];
                    let item = { partyId: Party, mlaLeads: Leads };
                    if(mpRows&&mpRows[i]) {
                        item['mpLeads'] = mpRows[i].Leads;
                    }
                    // console.log('lead temp item=',item);
                    partyTempList.push(item);
                }
                partyTempList = partyTempList.sort((a,b) => (b.mpLeads+b.mlaLeads)-(a.mpLeads+a.mlaLeads));
            } else {
                for(let i=0;i<mpRows.length;i++) {
                    let { Party, Leads } = mpRows[i];
                    let item = { partyId: Party, mpLeads: Leads };
                    // console.log('lead temp item=',item);
                    partyTempList.push(item);
                }
                partyTempList = partyTempList.sort((a,b) => b.mpLeads-a.mpLeads);
            }
        }
        console.log('partyTempList=',partyTempList);
        return partyTempList;
    }

    const setStoredStatesData = (latestPartyList, storedStates, currentState) => {
        let currentStatesData = storedStates[currentState];
        console.log('currentStatesData=',currentStatesData);
        let { displayPartyList, group2Array, group1Array, mpMlaCount1, mpMlaCount2 } = currentStatesData;
        // console.log('latestPartyList=',latestPartyList);
        // console.log('displayPartyList=',displayPartyList,' group1Array=',group1Array);
        let currentPartyListLength = displayPartyList.length+group1Array.length+group2Array.length;
        let shouldReset = latestPartyList.length!=currentPartyListLength;
        for(let i=0;i<displayPartyList.length;i++) {
            let { partyId } = displayPartyList[i];
            let obj = latestPartyList.find(o => o.partyId === partyId);
            if(obj) {
                displayPartyList[i] = obj;
            } else {
                shouldReset = true;
            }
        }
        for(let i=0;i<group1Array.length;i++) {
            let { partyId } = group1Array[i];
            let obj = latestPartyList.find(o => o.partyId === partyId);
            if(obj) {
                group1Array[i] = obj;
            } else {
                shouldReset = true;
            }
        }
        for(let i=0;i<group2Array.length;i++) {
            let { partyId } = group2Array[i];
            let obj = latestPartyList.find(o => o.partyId === partyId);
            if(obj) {
                group2Array[i] = obj;
            } else {
                shouldReset = true;
            }
        }
        if(shouldReset) {
            setDisplayPartyList(latestPartyList);
            setFilterPartyList(latestPartyList);
            setGroup1List([]);
            setGroup2List([]);
            setMpMla1Count({ mp: 0, mla: 0 });
            setMpMla2Count({ mp: 0, mla: 0 });
            let newStoredStates = { ...storedStates };
            newStoredStates[currentState] = '';
            localStorage.setItem('storedStates', JSON.stringify(newStoredStates));
        } else {
            setGroup1List(group1Array);
            setGroup2List(group2Array);
            let { mlaLeadsGroup1, mlaLeadsGroup2, mpLeadsGroup1, mpLeadsGroup2, parties }
                = calculateLeads(props, group1Array, group2Array, latestPartyList);
            setMpMla1Count({ mla: mlaLeadsGroup1, mp: mpLeadsGroup1 });
            setMpMla2Count({ mla: mlaLeadsGroup2, mp: mpLeadsGroup2 });
            setDisplayPartyList(parties);
            setFilterPartyList(parties);
            setStatesObject(storedStates);
        }
    }

    const onDrop = (dragItem, groupIndex) => {
        console.log('onDrop called. dragItem=',dragItem);
        let newPartyList = displayPartyList.filter(item => item.partyId !== dragItem.partyId);
        let { currentState } = props;
        let updatedPartyList = [];
        let group1Array = group1List, group2Array = group2List, mpMlaCount1 = mpMla1Count, mpMlaCount2 = mpMla2Count;
        if(groupIndex==2) {
            let obj = group2List.find(o => o.partyId === dragItem.partyId);
            if(obj) {
                group2Array = [...group2List];
            } else {
                group2Array = [...group2List, dragItem];
            }
            group1Array = group1List.filter(o => o.partyId != dragItem.partyId);
            setGroup1List(group1Array);
            setGroup2List(group2Array);
            // console.log('first count group2 leads=',group2Array);
            let { mlaLeadsGroup1, mlaLeadsGroup2, mpLeadsGroup1, mpLeadsGroup2, parties }
                = calculateLeads(props, group1Array, group2Array, allPartyList);
            mpMlaCount2 = { mla: mlaLeadsGroup2, mp: mpLeadsGroup2 };
            updatedPartyList = parties;
            setMpMla2Count(mpMlaCount2);
            // console.log('count group1 leads=',group1Array);
            mpMlaCount1 = { mla: mlaLeadsGroup1, mp: mpLeadsGroup1 };
            setMpMla1Count(mpMlaCount1);
        } else {
            let obj = group1List.find(o => o.partyId === dragItem.partyId);
            if(obj) {
                group1Array = [...group1List];
            } else {
                group1Array = [...group1List, dragItem];
            }
            group2Array = group2List.filter(o => o.partyId != dragItem.partyId);
            setGroup2List(group2Array);
            setGroup1List(group1Array);
            let { mlaLeadsGroup1, mlaLeadsGroup2, mpLeadsGroup1, mpLeadsGroup2, parties }
                = calculateLeads(props, group1Array, group2Array, allPartyList);
            mpMlaCount1 = { mla: mlaLeadsGroup1, mp: mpLeadsGroup1 };
            updatedPartyList = parties;
            setMpMla1Count(mpMlaCount1);
            mpMlaCount2 = { mla: mlaLeadsGroup2, mp: mpLeadsGroup2 };
            setMpMla2Count(mpMlaCount2);
        }
        setDisplayPartyList(updatedPartyList);
        setFilterPartyList(updatedPartyList);
        setDragItem('');
        let stateObj = { displayPartyList: updatedPartyList, group2Array, group1Array, mpMlaCount1, mpMlaCount2 };
        let storedStates = { ...statesObject };
        storedStates[currentState] = stateObj;
        localStorage.setItem('storedStates', JSON.stringify(storedStates));
    }

    const removeGroupParty = (groupIndex, deleteItem) => {
        console.log('groupIndex=',groupIndex,' deleteItem=',deleteItem);
        let newPartyList = [ deleteItem, ...displayPartyList ];
        for(let i=0;i<newPartyList.length;i++) {
            let item = newPartyList[i];
            let origialItem = allPartyList.find(o => o.partyId === item.partyId);
            newPartyList[i] = origialItem;
        }
        // console.log('newPartyList=',newPartyList);
        let { currentState } = props;
        let updatedPartyList = [];
        let group1Array = group1List, group2Array = group2List, mpMlaCount1 = mpMla1Count, mpMlaCount2 = mpMla2Count;
        if(groupIndex==2) {
            group2Array = group2List.filter(item => item.partyId !== deleteItem.partyId);
            setGroup2List(group2Array);
            let { mlaLeadsGroup1, mlaLeadsGroup2, mpLeadsGroup1, mpLeadsGroup2, parties }
                = calculateLeads(props, group1Array, group2Array, allPartyList);
            mpMlaCount2 = { mla: mlaLeadsGroup2, mp: mpLeadsGroup2 };
            updatedPartyList = parties;
            setMpMla2Count(mpMlaCount2);
            mpMlaCount1 = { mla: mlaLeadsGroup1, mp: mpLeadsGroup1 };
            setMpMla1Count(mpMlaCount1);
        } else {
            group1Array = group1List.filter(item => item.partyId !== deleteItem.partyId);
            setGroup1List(group1Array);
            let { mlaLeadsGroup1, mlaLeadsGroup2, mpLeadsGroup1, mpLeadsGroup2, parties }
                = calculateLeads(props, group1Array, group2Array, allPartyList);
            mpMlaCount1 = { mla: mlaLeadsGroup1, mp: mpLeadsGroup1 };
            updatedPartyList = parties;
            setMpMla1Count(mpMlaCount1);
            mpMlaCount2 = { mla: mlaLeadsGroup2, mp: mpLeadsGroup2 };
            setMpMla2Count(mpMlaCount2);
        }
        setDisplayPartyList(updatedPartyList);
        setFilterPartyList(updatedPartyList);
        let stateObj = { displayPartyList: updatedPartyList, group2Array, group1Array, mpMlaCount1, mpMlaCount2 };
        let storedStates = { ...statesObject };
        storedStates[currentState] = stateObj;
        localStorage.setItem('storedStates', JSON.stringify(storedStates));
    }

    const handleInputChange = (event) => {
        let tempValue = event.target.value;
        setQuery(tempValue);
        if(tempValue) {
            tempValue = tempValue.toUpperCase();
            let filteredParties = displayPartyList.filter(element => {
                return element.partyId.includes(tempValue);
            });
            setFilterPartyList(filteredParties);
        } else {
            setFilterPartyList(displayPartyList);
        }
    };

    const onMapChartChange = (e) => {
        let value = e.target.value;
        console.log('mp mla radio checked', value);
        setMapChartRadio(value);
    }

    const onDragEnd = (result) => {
        console.log('result=',result);
        const { source, destination, draggableId } = result;
        console.log('destination=',destination,' draggableId=',draggableId);
        if (!destination) return;
        if(source.droppableId==destination.droppableId) return;
        if(destination.droppableId == 'partiesGroup') return;
        if(source.droppableId == 'partiesGroup') {
            let item = filterPartyList.find(o => o.partyId===draggableId);
            if(destination.droppableId == 'groupA') {
                onDrop(item, 1);
            } else if(destination.droppableId == 'groupB') {
                onDrop(item, 2);
            }
        } else if(source.droppableId == 'groupA'&&destination.droppableId == 'groupB') {
            let item = group1List.find(o => o.partyId===draggableId);
            onDrop(item, 2);
        } else if(source.droppableId == 'groupB'&&destination.droppableId == 'groupA') {
            let item = group2List.find(o => o.partyId===draggableId);
            onDrop(item, 1);
        }
    }

    const groupUI = (index) => {
        let bgColor = '#7BACF5', title = group1Name, groupList = group1List, countObj = mpMla1Count;
        if(index==2) {
            bgColor = '#EE3D63'; title = group2Name; groupList = group2List; countObj = mpMla2Count;
        }
        let { mp, mla } = countObj;
        let { isMpMla } = props;
        let isIndia = stateIndex==0;
        let droppableKeyId = index==2 ? 'groupB' : 'groupA';
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: 350, height: groupsHeight/2-13,
            marginLeft: 20, backgroundColor: '#F5F6FF', border: '2px solid '+bgColor }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', outline: 'none',
                    height: 50, color: '#fff', backgroundColor: bgColor, fontSize: 20, fontWeight: 600 }}>
                        {title}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', height: 50, marginTop: -10 }}>
                        <div style={{ flex: 1, display: isIndia||(!isMpMla.mla) ? 'none' : 'flex',
                        alignItems: 'center', justifyContent: 'center', color: '#fff', backgroundColor: bgColor,
                        fontSize: 20, fontWeight: 600 }}>
                            MLA - {mla}
                        </div>
                        <div style={{ flex: 1, display: isMpMla.mp ? 'flex' : 'none', alignItems: 'center',
                        justifyContent: 'center', color: '#fff', backgroundColor: bgColor, fontSize: 20,
                        fontWeight: 600, }}>
                            MP - {mp}
                        </div>
                    </div>
                    <Droppable droppableId={droppableKeyId} key={droppableKeyId}>
                    {(provided, snapshot) => {
                        return (
                        <div {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={{ display: 'flex', flexDirection: 'column', flex: 1, overflowY: 'scroll',
                        overflowX: 'hidden', alignItems: 'center', paddingBottom: 50 }}>
                            {groupList.map((item, indexCol) => {
                            return (
                                <Draggable key={item.partyId} draggableId={item.partyId} index={indexCol}>
                                    {(provided, snapshot) => {
                                    return (
                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                        style={{ userSelect: "none", ...provided.draggableProps.style }}>
                                            <PartyUI2 key={indexCol} partyItem={item} partyLogos={partyLogos}
                                            stateIndex={stateIndex} removeGroupParty={() => removeGroupParty(index, item)}
                                            isMpMla={isMpMla} />
                                        </div>
                                    );
                                    }}
                                </Draggable>
                            );
                            })}
                            {provided.placeholder}
                        </div>
                        );
                    }}
                    </Droppable>
            </div>
        );
    }

    console.log('dragItem=',dragItem,' group1List=', group1List,' groupsWidth=',groupsWidth,
    ' contentWidth=',contentWidth);

    return (
        <div style={{  display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', paddingTop: 20 }}>
                <DragDropContext onDragEnd={result => onDragEnd(result)} >
                    <div style={{ width: 'auto', marginLeft: 20, overflow: 'hidden' }}>
                        <div style={{ width: 334, height: contentHeight-21, backgroundColor: '#F5F6FF',
                        border: '2px solid #D5D6DD', overflow: 'hidden' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',
                            backgroundColor: '#FFFAFA', width: 'auto', height: 90, border: '0px solid #D5D6DD',
                            borderBottomWidth: 2, zIndex: 2 }}>
                                <input type="text" value={query} onChange={handleInputChange}
                                style={{ height: 24, padding: 8, border: '1px solid #B5B6BB',
                                fontWeight: 'bold', fontSize: 16, color: '#5a6a7a', outline: 'none' }} />
                            </div>
                            <div style={{ width: 334, height: contentHeight-110, overflowY: 'scroll',
                            overflowX: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Droppable droppableId={'partiesGroup'} key={'partiesGroup'}>
                                {(provided, snapshot) => {
                                    return (
                                    <div {...provided.droppableProps}
                                    ref={provided.innerRef}>
                                        {filterPartyList.map((item, index) => {
                                            return (
                                            <Draggable key={item.partyId} draggableId={item.partyId} index={index}>
                                                {(provided, snapshot) => {
                                                return (
                                                    <div ref={provided.innerRef} {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={{ userSelect: "none", ...provided.draggableProps.style }}>
                                                        <PartyUI1 key={index} partyItem={item} partyLogos={partyLogos}
                                                        stateIndex={stateIndex} isMpMla={props.isMpMla} />
                                                    </div>
                                                );
                                                }}
                                            </Draggable>
                                            );
                                        })}
                                        {provided.placeholder}
                                    </div>
                                    );
                                }}
                                </Droppable>
                                <div style={{ height: 50 }} />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: 20 }}>
                        {groupUI(1)}
                        <div style={{ height: 20 }} />
                        {groupUI(2)}
                    </div>
                </DragDropContext>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Map mapWidth={contentWidth-760} mapHeight={groupsHeight} partyLeadsMap={partyLeadsMap}
                    toolTipObj={toolTipObj} stateMLAMap={props.stateMLAMap} stateMPMap={props.stateMPMap}
                    group1List={group1List} group2List={group2List} currentStateData={stateResults[currentState]}
                    currentState={currentState} stateResults={stateResults} isMpMla={props.isMpMla} />
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <BarChart mapWidth={contentWidth} mpMla1Count={mpMla1Count} mpMla2Count={mpMla2Count}
                group1List={group1List} group2List={group2List} currentState={currentState}
                stateResults={stateResults} allPartyList={allPartyList} partyLogos={partyLogos} />
            </div>
        </div>
    );
}

export default Analysis;